/**
 * Escrow collection accessors.
 *
 * The backend `EscrowItem` model keeps BOTH stored fields (`months_collected`,
 * `escrow_amount_collected`) and a computed `escrow_collection` property that
 * recomputes them from the expected closing date. Because Pydantic serializes
 * the stored fields BEFORE the computed ones run, the stored pair arrives stale
 * (0/0) on any loan whose escrow item hasn't been re-saved since the closing
 * date last moved — while `escrow_collection` (and `totalDueAmount`, computed
 * after it) carry the live numbers. Always read the computed values first.
 */

export const getEscrowMonthsCollected = (item) =>
  item?.escrow_collection?.months_to_collect ?? item?.months_collected ?? null;

export const getEscrowAmountCollected = (item) =>
  item?.escrow_collection?.amount_to_collect ??
  item?.totalDueAmount ??
  item?.escrow_amount_collected ??
  null;
